import type { StyleLayer } from './utils/types'

export const layers_radinfra_oneway: StyleLayer[] = [
  {
    id: 'oneway-color',
    type: 'line',
    filter: ['match', ['get', 'oneway'], ['no', 'yes', 'car_not_bike'], true, false],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': [
        'match',
        ['get', 'oneway'],
        ['no'],
        '#00c29e',
        ['yes'],
        '#a1e217',
        ['car_not_bike'],
        '#00c29e',
        'black',
      ],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-opacity': ['match', ['get', 'oneway'], ['car_not_bike'], 0.5, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
  {
    id: 'oneway-color-dashed',
    type: 'line',
    filter: ['match', ['get', 'oneway'], ['car_not_bike'], true, false],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#00c29e',
      'line-dasharray': [0.1, 1.5],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
  {
    id: 'oneway-missing',
    type: 'line',
    filter: ['match', ['get', 'oneway'], ['implicit_yes', 'assumed_no'], true, false],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': [
        'match',
        ['get', 'oneway'],
        ['assumed_no'],
        '#fda5e4',
        ['implicit_yes'],
        '#d8a5fd',
        'black',
      ],
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 1, 22, 4],
    },
  },
  {
    id: 'hitarea-missing-oneway',
    type: 'line',
    filter: ['match', ['get', 'oneway'], ['implicit_yes', 'assumed_no'], true, false],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
  {
    id: 'oneway-zoomed-out',
    type: 'line',
    filter: ['!', ['has', 'oneway']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'gray',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
]
